import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import InputGroup from 'react-bootstrap/InputGroup';

export const Schema = Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true).max(999999,"Zahl ist zu groß")
        .positive("Nur positive Zahlen")
        .test("Length", "Es sind nur 2 Nachkommastellen erlaubt", val => {
            if (val) return val.toString().length <= 9;
            return true;
        })
        .required("Angabe ist erforderlich"),
});

export const SalaryRequestSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltswunsch jährlich*</Form.Label>
                <InputGroup className="mb-3">
                    <CustomFormControl
                        colors={colors}
                        placeholder="Jährlichen Gehaltswunsch eingeben"
                        type="text"
                        name="salaryRequest"
                        value={values.salaryRequest || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.salaryRequest && !errors.salaryRequest}
                        isInvalid={touched.salaryRequest && errors.salaryRequest}
                        maxLength={9}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.salaryRequest}
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>
        </>
    );
};